export const getPageNameFromPath = path => {
  const pathArr = path.split('/')
  return pathArr[pathArr.length - 1] === '' ? 'home' : pathArr[pathArr.length - 1]
}

const routes = {
  home: '/',
  walkthrough: '/walkthrough',
  resources: '/resources',
  social: '/social',
  vaultVerification: '/vault-verification',
  auth: {
    signIn: '/auth/sign-in',
    signOut: '/auth/sign-out',
    forgotPassword: '/auth/forgot-password',
  },
  claimBusiness: '/claim-business',
  verificationRoute: '/verification',
  myAccount: '/my-account',
  myBusiness: '/claimed-business',
  welcome: '/welcome',
  ownerBeneficialForm: '/ownerBeneficialForm',
  businessDetails: '/businessDetails',
  find: '/find',
  details: '/details',
  claim: '/claim',
  vault: '/vault',
  correctYourData: '/correct-your-data',
}

export default routes
